export default __webpack_public_path__ + "static/media/people_mobile_banner.117f35f8.png";